import { useTranslation } from '../../i18n'
import './SocialProof.css'

const companies = ['Epam', 'Infosys', 'Wipro', 'GlobalLogic', 'Capgemini', 'Cognizant', 'TCS', 'Luxoft']

function SocialProof() {
  const { t } = useTranslation()

  const testimonials = [
    {
      nameKey: 'socialProofTestimonial1Name' as const,
      roleKey: 'socialProofTestimonial1Role' as const,
      textKey: 'socialProofTestimonial1Text' as const,
    },
    {
      nameKey: 'socialProofTestimonial2Name' as const,
      roleKey: 'socialProofTestimonial2Role' as const,
      textKey: 'socialProofTestimonial2Text' as const,
    },
    {
      nameKey: 'socialProofTestimonial3Name' as const,
      roleKey: 'socialProofTestimonial3Role' as const,
      textKey: 'socialProofTestimonial3Text' as const,
    },
  ]

  return (
    <section className="social-proof-section section" aria-label="Social proof">
      <div className="container">
        <div className="section-title">
          <h2>{t('socialProofTitle')}</h2>
        </div>

        {/* User counter */}
        <div className="user-counter">
          <span className="counter-number">2,500+</span>
          <span className="counter-label">{t('socialProofWaitlist')}</span>
        </div>

        {/* Testimonials */}
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-stars">★★★★★</div>
              <p className="testimonial-text">"{t(testimonial.textKey)}"</p>
              <div className="testimonial-author">
                <div className="author-avatar">
                  {t(testimonial.nameKey).charAt(0)}
                </div>
                <div className="author-info">
                  <span className="author-name">{t(testimonial.nameKey)}</span>
                  <span className="author-role">{t(testimonial.roleKey)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Company logos */}
        <div className="companies-section">
          <p className="companies-title">{t('socialProofCompaniesTitle')}</p>
          <div className="companies-bar">
            {companies.map((company) => (
              <span key={company} className="company-name">{company}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default SocialProof
